import * as React from "react"
import { App } from "./app"
import { BDKalkCore } from "./BDKalkCore"
import { PADebug } from "./PADebug"
import { SelectionSetGW } from "./SelectionSetGW"
import { MakeNational } from "./BDKalkCore"

///////////////   SummaryView  ////////////////

/*SummaryView displays a list of specific article choises, based on selectd articles with sub choises and also based on selected build parts. */

export interface SummaryViewVm  {
    app: App
}

export interface SummaryViewStateVm {
    question: string,
    loadStage: string,
    pdfLoaded: boolean
    /*  question - "unanswered" : At this stage the user is asked to have contents shown as rounded up to nearest orderable package type, or to see it unchanged.
        question - "unchanged" : Contents of the item selections are shown as is, without rounding up or converting into smallest orderable package type.
        question - "converted" : Contents are converted into smallest orderable package type and rounded up to nearest full package.

        stage - "initial" : while contents are being generated, showing "Generating quick report..." or similar
        stage - "generated" : When the m_summarySet has been generated from selection and selected build parts an is ready to be displayed

        pdfLoaded - false  the ID required for showing a pdf file of the contents has not yet been recieved from the server, so the pdf link remains inactive.
        pdfLoaded - true  the ID required for showing a pdf file has been recieved and a pdf file can be generated upon request, so the pdf link is shown and active 
    */
}

export class SummaryView extends React.Component<SummaryViewVm, SummaryViewStateVm> {
    state = {
        question: "unchanged",
        loadStage: "initial",
        pdfLoaded: false
    }
    
    constructor(props: SummaryViewVm) {
        super(props)
        this.m_PDFID = "2E126312-A8A9-4BEA-3301-08D5CA266E4F" // temp
        this.m_summarySet = new SelectionSetGW()
        this.m_pdfidRequestSent = false
        this.m_fpakSum = { sum: 0 }
        this.m_serverUrl = props.app.ServerUrl;
        this.m_hoveredRadioIndex = -1
        this.m_hasSavedSummarySet = false
    }

    componentWillMount() {
        this.props.app.GetCore().ConnectSummaryView(this)
    }
    
    SaveSummarySet() {
        if (this.m_hasSavedSummarySet == true) {
            return
        }

        const core = this.props.app.GetCore()
        var parts = core.GetSelectedBuildParts()

        if (parts.length > 0) {
            this.m_summarySet = new SelectionSetGW()
            this.m_summarySet.InitFromArticles(core.GetSelectedArticles())

            for (var i = 0; i < parts.length; i++) {
                this.m_summarySet.AddFromBuildPartsRecursion(parts[i], parts[i].GetAmount())
            }
        }
        else {
            this.m_summarySet = new SelectionSetGW()
            this.m_summarySet.InitFromArticles(core.GetSelectedArticles())
        }
        
        const manager = this.props.app.GetCore().GetSelectionSetManager()
        this.m_summarySet.SetMeta("HN" + manager.GetVersion())
        this.m_summarySet.ClearZeroAmounts()
        this.m_summarySet.SetName(manager.GetCurrentProjectName())
        
        manager.SaveSelectionSet(this.m_summarySet, manager.GetQRID(), this.OnSavedSetForPDF.bind(this))

        setTimeout(this.props.app.GetCore().GenerateArticleSummary.bind(this.props.app.GetCore()), 15)

        this.m_hasSavedSummarySet = true
    }

    OnArticleSummaryLoaded() {
        if (this.state.loadStage == "initial") {
            this.setState({ loadStage: "Generated" })
            return
        }
        
        PADebug.Assert(false, "SummaryView.OnArticleSummaryLoaded - summary got loaded but the stage is not `initial` ..? (This should never happen) stage is:" + this.state.loadStage )
    }
 
    OnSavedSetForPDF(returnedID: string) {
        this.m_PDFID = JSON.parse(returnedID).id

        this.setState({ pdfLoaded: true })
    }

    OnAnswerConvert() {
        this.props.app.GetCore().SetSummaryModeRadioIndex(1)
        this.setState({ question: "converted" })
    }

    OnAnswerUnchanged() {
        this.props.app.GetCore().SetSummaryModeRadioIndex(0)
        this.setState({ question: "unchanged"})
    }
    
    render() {
        // Showing a loading text instead of contents because contents aren't fully loaded yet
        if ((this.state.question == "unanswered") || (this.props.app.GetCore().GetSummaryModeRadioIndex() == -1)) {
            if ((this.props.app.GetCore().GetSelectedArticles().length == 0) && (this.props.app.GetCore().GetSelectedBuildParts().length == 0)) {
                // Nothing to show, ignoring the conversion question and showing the report (as unconverted)
            }
            else {
                return <div style={{ display: "flex", flexDirection: "row" }}>
                    <div style={{ width: "calc(50% - 140px)", height: "1px" }}>
                    </div>
                    <div style={{ position: "relative", top: "80px", display: "flex", flexDirection: "column" }}>
                        <div>Ønsker du at se valgte artikler som nå</div>
                        <div>med sine primære prisenheter eller</div>
                        <div>ønsker du at få dem konvertert til minste</div>
                        <div>bestillbare pakke enheter og få disse</div>
                        <div>avrundet opp til nermeste hele pakke?</div>

                        <div style={{ position: "relative", top: "5px", display: "flex", flexDirection: "row" }}>
                            <div onClick={this.OnAnswerUnchanged.bind(this)} style={{ backgroundColor: "grey", width: "114px", height: "30px", position: "relative", top: "20px", cursor: "pointer" }}>
                                <div style={{ position: "relative", top: "6px", left: "12px", color: "white", cursor: "pointer" }}>
                                    Vis uførendret
                                </div>
                            </div>

                            <div onClick={this.OnAnswerConvert.bind(this)} style={{ backgroundColor: "grey", width: "170px", height: "30px", position: "relative", top: "20px", left: "20px", cursor: "pointer" }}>
                                <div style={{ position: "relative", top: "6px", left: "12px", color: "white", cursor: "pointer" }}>
                                    Konverter og runde opp
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            }
        }


        // Checking that nobb info is loaded for all selected articles or showing how much in percentage is left otherwise
        var perc = this.props.app.GetCore().GetQReportReadinessPercentage()
        if (perc < 1.0) {
            setTimeout(this.forceUpdate.bind(this), 250)
            return <div>
                Forbereder utskrift: {this.props.app.GetCore().GetQReportReadinessPercentageString()}
            </div>
        }

        // Initiates the summary set now that all selected articles have nobb info provided...
        this.SaveSummarySet()

        // Showing a loading text instead of contents because contents aren't fully loaded yet
        if (this.state.loadStage == "initial") {

            return <div>
                Forbereder utskrift...
            </div>
        }

        var totalValue = this.props.app.GetCore().TotalSumExMva()

        var ordersSection = this.RenderOrders()

        if (this.props.app.GetCore().GetSummaryModeRadioIndex() == 1) {
            totalValue = this.m_fpakSum.sum
        }

        const mva = this.props.app.GetCore().GetMva()

        var resultTotal = this.RefinePriceString(totalValue.toString())
        var resultMVA = this.RefinePriceString((totalValue * mva).toString())
        var resultInclMVA = this.RefinePriceString((totalValue + (totalValue * mva)).toString())

        var mvaSection = < div style={{ width: "100%", height: "18px", display: 'flex', flexDirection: 'row', marginLeft: '20px' }} >
            <div style={{ width: "37%", position: "relative", top: "7px" }}>Herav mva:</div>
            <div style={{ width: "10%", position: "relative", top: "7px", left: "-7px", textAlign: "right" }}>{resultMVA}</div>
            <div style={{ width: "55%" }}></div>
        </div >

        var shownSum = resultTotal
        var shownSumText = "Sum exkl. mva"

        if (this.props.app.GetCore().GetPriceFlags() & 4) { // Mva is displayed
            shownSum = resultInclMVA
            shownSumText = "Sum inkl. mva"
        }
        else {
            mvaSection = <div></div>
        }

        const marginLeft = "15px"
        const radioUncheckedPos = "0px -136px"
        const radioHoverPos = "0px -172px"
        const radioCheckedPos = "0px -154px"

        var radio01Pos = radioUncheckedPos
        var radio02Pos = radioUncheckedPos

        if (this.m_hoveredRadioIndex == 0) {
            radio01Pos = radioHoverPos
        }

        if (this.m_hoveredRadioIndex == 1) {
            radio02Pos = radioHoverPos
        }

        if (this.props.app.GetCore().GetSummaryModeRadioIndex() == 0) {
            radio01Pos = radioCheckedPos
        }

        if (this.props.app.GetCore().GetSummaryModeRadioIndex() == 1) {
            radio02Pos = radioCheckedPos
        }

        var fpakFlag = 0

        if (this.props.app.GetCore().GetSummaryModeRadioIndex() == 1) {
            fpakFlag = 8
        }

        var priceMode = this.props.app.GetCore().GetPriceRadio().toString()
        var priceFlags = (this.props.app.GetCore().GetPriceFlags() | fpakFlag).toString()
        var priceMode = "/?priceMode=" + priceMode + "&priceFlags=" + priceFlags
        
        /*
            /api/report/(selection id)/?priceMode=2&priceFlags=4

            priceMode == 0   : Ingen priser (=0)
            priceMode == 1   : Grunn-/prosjektpriser    
            priceMode == 2   : Veil. pris
            priceMode == 3   : Fabrikk pris

            priceFlags & 1   : Rabatt (til Grunn-prosjekt pris)
            priceFlags & 2   : Påslag (til Grunn-prosjekt pris)
            priceFlags & 4   : Mva inregnet i enhets pris
            priceFlags & 8   : Alle resultater skal vare omregnet til minste bestillbare enhet, rundet opp
        */
        
        var pdfLink = <a href={this.m_serverUrl + "api/report/" + this.m_PDFID + priceMode} target="_blank"> <u> Laste ned som pdf </u> </a>

        if (this.state.pdfLoaded == false) {
            pdfLink = <u> Forbereder PDF... </u>
        }

        var radioSection = <div>
           <div style={{ width: "410px", height: "72px", fontSize: "28px", fontWeight: "bold", marginLeft: marginLeft, backgroundColor: "#EAF3FF" }}
                onMouseLeave={(e) => this.OnExitRadioButtons()}>
                <div style={{ display: "flex", flexDirection: "row", position: "relative", top: "8px", left: "7px" }}
                    onClick={(e) => this.OnClickRadio01()}
                    onMouseEnter={(e) => this.OnEnterRadio01()}>
                    <div style={{ backgroundImage: "url(images/UtvidetInfoTab.png)", backgroundPosition: radio01Pos, width: "16px", height: "18px", position: "relative", top: "3px" }}></div>
                    <div style={{ fontWeight: "normal", marginLeft: "10px", height: "25px", marginTop: "5px" }}> Vis uførendret </div>
                </div>
                <div style={{ display: "flex", flexDirection: "row", position: "relative", top: "8px", left: "7px" }}
                    onClick={(e) => this.OnClickRadio02()}
                    onMouseEnter={(e) => this.OnEnterRadio02()}>
                    <div style={{ backgroundImage: "url(images/UtvidetInfoTab.png)", backgroundPosition: radio02Pos, width: "16px", height: "18px", position: "relative", top: "3px" }}></div>
                    <div style={{ fontWeight: "normal", marginLeft: "10px", height: "25px", marginTop: "5px" }}> Konverter og runde opp til minste bestillbare pakke enhet </div>
                </div>
            </div>
            <div style={{ height: "20px" }}></div>
        </div>
        
        return <div className="pageSection" style={{ width: "100%" }}>
            <div style={{ display: "flex", direction: "row", marginLeft: "20px", marginTop: "16px" }}>
                <h2 style={{ width: "calc(100% - 145px)" }}>Utvalg: {this.props.app.GetCore().GetSelectionSetManager().GetCurrentProjectName()}</h2>
                <div style={{ fontVariant: "underlined", position: "relative", color: "#5969B9", top: "6px", left: "0px", cursor: "pointer" }}>
                    {pdfLink}
                </div>
            </div>

            {/* Display modus radio buttons */}
            {radioSection}
            
            {/*   Articles Body   */}
            <div className="pageSection" style={{ width: "100%" }}>
                {/*  ( Articles Section Contents )  */
                    ordersSection
                }
            </div>

            <div className="pageSection" style={{ position: "relative", top: "16px", width: "100%", borderTop: "1px solid #B9B9B9", borderBottom: "1px solid #B9B9B9", font: "bold" }}>
                {/* Total sum */}
                <div style={{ width: "100%", height: "18px", display: 'flex', flexDirection: 'row', marginLeft: '20px' }} >
                    <div style={{ width: "37%", position: "relative", top: "7px" }}>{shownSumText}</div>
                    <div style={{ width: "10%", position: "relative", top: "7px", left: "-7px", textAlign: "right" }}>{shownSum}</div>
                    <div style={{ width: "55%" }}></div>
                </div>

                {/* MVA */
                    mvaSection
                }

                <div style={{ height: "10px" }} >
                </div>
            </div>
        </div>
    }
    
    OnExitRadioButtons() {
        this.m_hoveredRadioIndex = -1
        this.forceUpdate()
    }

    OnClickRadio01() {
        this.m_hoveredRadioIndex = -1
        this.props.app.GetCore().SetSummaryModeRadioIndex(0)
        this.setState({ question: "unchanged" })
        this.forceUpdate()
    }

    OnEnterRadio01() {
        this.m_hoveredRadioIndex = 0
        this.forceUpdate()
    }

    OnClickRadio02() {
        this.m_hoveredRadioIndex = -1
        this.props.app.GetCore().SetSummaryModeRadioIndex(1)
        this.setState({ question: "converted" })
        this.forceUpdate()
    }

    OnEnterRadio02() {
        this.m_hoveredRadioIndex = 1
        this.forceUpdate()
    }

    RenderOrders() {
        this.m_fpakSum = { sum: 0 }
        return this.props.app.GetCore().RenderOrders(this.props.app.GetCore().GetSummaryModeRadioIndex() == 1, this.m_fpakSum)
    }

    GetFpakSum(originalString : string) {
        if (this.props.app.GetCore().GetSummaryModeRadioIndex() == 1) {
            return this.RefinePriceString(this.m_fpakSum.sum.toString())
        }
        else {
            return originalString
        }
    }

    RefinePriceString(value : string) {
        var result = value
        var decimalsShown = 0
        var passedComma = false
        var fpakSum: { sum: number } = { sum: 0 }

        // Counting the decimals of the total sum string
        for (var i = 0; i < result.length; i++) {
            if (passedComma == true) {
                decimalsShown++
            }

            // Ensuring there is no more than two decimals shown
            if (decimalsShown > 2) {
                result = result.slice(0, i)
                break
            }

            if (result[i] == '.') {
                passedComma = true
            }
        }

        // Ensuring there is allways two decimals shown on the total sum
        if (decimalsShown == 0) {
            result += ".00"
        }

        if (decimalsShown == 1) {
            result += "0"
        }

        return MakeNational(result)
    }
    
    private m_name: string // keeps the name while the view gets unmounted due to changes in the stage
    private m_projectName: HTMLInputElement
    private m_PDFID: string
    private m_summarySet: SelectionSetGW
    private m_pdfidRequestSent: boolean
    private m_fpakSum: { sum: number }
    private m_serverUrl: string
    private m_hoveredRadioIndex: number
    private m_hasSavedSummarySet: boolean
}





// WEBPACK FOOTER //
// ./client/view/SummaryView.tsx